/**
 * Csv Schema of RotaSla
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {RotaSla} from '@/model/resource/RotaSla'

/* TODO: review generated schema */
export class CsvRotaSlaSchema extends Schema {
  readonly name = 'CsvRotaSla'

  readonly fieldSet: FieldSet<RotaSla> = {
    pontaSla1: schema => schema.model.pontaSla1?.$id ?? null,
    pontaSla2: schema => schema.model.pontaSla2?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    valor: schema => schema.model.valor,
  }
}
